import React from "react"
import { Link } from "gatsby"
import Img from 'gatsby-image';
import PortableText from "@sanity/block-content-to-react"
import slugify from 'slugify'

import Review from "./review"
import { getPostDate } from "../utils/date"
import samplePostCover from "../../images/posts/post-img.jpg"

import { Wrapper } from "./style"

const Post = ({ title, body, date, featuredimage, tags }) => {
  return (
    <Wrapper>
      <div id="post">
        <Img fluid={featuredimage ? featuredimage : samplePostCover} alt={title} />
        <div className="post_details">
          <h2>{title}</h2>
          <PortableText blocks={body} className="post_content" />
          <div className="post_meta">
            <p>Date Posted: {getPostDate(date).toString()}</p>
            {/* <div>
              <span>Star 120</span>
              <span>Comments 50</span>
            </div> */}
          </div>
          <ul className="tags_container">
            {tags.map((tag, i) => (
              <li className="tag" key={i}>
                <Link to={`/tags/${slugify(tag.name)}/`}>{tag.name}</Link>
              </li>
            ))}
          </ul>
          {/* <div id="comments">
            <Review />
            <Review />
            <Review />
            <Review />
          </div> */}
        </div>
      </div>
    </Wrapper>
  )
}

export default Post
